import styled from '@emotion/styled';
import dayjs, { Dayjs } from 'lib/dayjs';
import { useEffect, useMemo, useState, HTMLAttributes } from 'react';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: var(--ant-error-color);
  > span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 22px;
    margin: 0 2px;
    border: solid 1px var(--ant-error-color);
    border-radius: 2px;
  }
`;

export interface CountDownProps extends HTMLAttributes<HTMLDivElement> {
  time: number;
}

const getCountDown = (time: Dayjs) => {
  const now = dayjs();

  const hours = time.diff(now, 'hours');
  const minutes = time.diff(now, 'minutes');
  const seconds = time.diff(now, 'seconds');
  const safeHours = Math.max(hours, 0);
  const safeMinutes = Math.max(minutes % 60, 0);
  const safeSeconds = Math.max(seconds % 60, 0);

  return {
    hours: String(safeHours).padStart(2, '0'),
    minutes: String(safeMinutes).padStart(2, '0'),
    seconds: String(safeSeconds).padStart(2, '0'),
  };
};

function CountDown(props: CountDownProps) {
  const { time, ...otherProps } = props;

  const momentTime = useMemo(() => dayjs(time), [time]);

  const [countDown, setCountDown] = useState(() => getCountDown(momentTime));

  const { hours, minutes, seconds } = countDown;

  useEffect(() => {
    const timer = setInterval(() => {
      setCountDown(getCountDown(momentTime));
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [momentTime]);

  return (
    <Container {...otherProps}>
      <span>{hours}</span>:<span>{minutes}</span>:<span>{seconds}</span>
    </Container>
  );
}

export default CountDown;
